<template>
  <SideBar :header="{name: 'KPI', logo: HeaderLogo, to:{ name: 'mainHomes' }}" :items="filteredNavigations" :support="{title:$t('support'),icon:TelegramIcon,to:'https://t.me/DT_ECOSYSTEM_SUPPORT'}"/>
</template>
<script>
import {useBreakpoints} from '@/composables/useBreakpoints';
import {ref} from 'vue';
import {SideBar} from "@dt-ecosystem/ui/packages/vue2/dist/index"
import {
  HomeIcon,
  HeaderLogo,
  TaskIcon,
  ProjectIcon,
  TeamsIcon,
  ReportIcon,
  ProjectReportIcon,
  PermissionIcon,
  TelegramIcon
} from "../../assets/sidebarIcons"

export default {
  components: {
    SideBar,
  },
  computed: {
    navigations() {
      return [
        {
          title: this.$tc('menu.home'),
          to: {name: 'mainHomes'},
          icon: HomeIcon,
          permission: 'TASK_READ',
        },
        {
          title: this.$tc('menu.task', 2),
          to: {name: 'mainTasks'},
          icon: TaskIcon,
          permission: 'TASK_READ',
        },
        {
          title: this.$tc('menu.project', 2),
          to: {name: 'mainProjects'},
          icon: ProjectIcon,
          permission: 'PROJECT_READ',
        },
        {
          title: this.$tc('menu.team', 2),
          to: {name: 'mainTeams'},
          icon: TeamsIcon,
          permission: 'GROUP_READ',
        },
        {
          title: this.$tc('menu.report', 2),
          icon: ReportIcon,
          permission: ['REPORT_KANBAN_PROJECT_MANAGER_AND_MEMBER', 'REPORT_TRELLO_PROJECT_MANAGER_AND_MEMBER', 'REPORT_CHART_KANBAN_PROJECT', 'REPORT_CHART_TRELLO_PROJECT', 'REPORT_KANBAN_TRELLO_PROJECT_WITH_USER', 'REPORT_TIME_LEFT', 'REPORT_FOR_PROJECT', 'REPORT_ETM_DESKTOP'],
          children: [
            {
              title: this.$t('menu.projectOverview'),
              to: {name: 'mainReportsProjectOverview'},
              icon: ProjectReportIcon,
              permission: ['REPORT_CHART_KANBAN_PROJECT', 'REPORT_CHART_TRELLO_PROJECT'],
            },
            {
              title: this.$t('menu.projectReport'),
              to: {name: 'mainReportsProjectReport'},
              icon: ProjectReportIcon,
              permission: ['REPORT_CHART_KANBAN_PROJECT', 'REPORT_CHART_TRELLO_PROJECT'],
            },
            {
              title: this.$t('menu.timeSeries'),
              to: {name: 'mainReportsTimeSeries'},
              icon: ProjectReportIcon,
              permission: 'REPORT_TIME_LEFT',
            },
            {
              title: this.$t('menu.timeFrame'),
              to: {name: 'mainReportsTimeFrame'},
              icon: ProjectReportIcon,
            },
            {
              title: this.$t('menu.projectDetailsTask'),
              to: {name: 'mainReportsProjectDetailsTask'},
              icon: ProjectReportIcon,
              permission: 'REPORT_KANBAN_TRELLO_PROJECT_WITH_USER'
            },
            {
              title: this.$t('menu.projectDetailsManager'),
              to: {name: 'mainReportsProjectDetailsManager'},
              icon: ProjectReportIcon,
              permission: ['REPORT_KANBAN_PROJECT_MANAGER_AND_MEMBER','REPORT_TRELLO_PROJECT_MANAGER_AND_MEMBER']
            },
            {
              title: this.$t('menu.projectDetailsEmployee'),
              to: {name: 'mainReportsProjectDetailsEmployee'},
              icon: ProjectReportIcon,
              permission: ['REPORT_KANBAN_PROJECT_MANAGER_AND_MEMBER','REPORT_TRELLO_PROJECT_MANAGER_AND_MEMBER']
            },
            {
              title: this.$t('menu.usersTasksReport'),
              to: {name: 'mainReportsUserDailyTasks'},
              icon: ProjectReportIcon,
              permission: 'REPORT_FOR_PROJECT',
            },
            {
              title: this.$t('menu.dailyReport'),
              to: {name: 'mainReportsDailyReport'},
              icon: ProjectReportIcon,
              permission: 'REPORT_FOR_PROJECT'
            },
            {
              title: this.$t('menu.userActivity'),
              to: {name: 'mainReportsDailyActivity'},
              icon: ProjectReportIcon,
              permission: 'REPORT_FOR_PROJECT'
            },
          ]
        },
        {
          title: this.$tc('menu.permission', 2),
          to: {name: 'mainPermissions'},
          icon: PermissionIcon,
          permission: ['PERMISSION_READ', this.$store.state.userProfile.systemAdmin]
        },
      ]
    },
    isMainPage() {
      const mainPageRoute = '/main/homes/index';
      return this.$route.path === mainPageRoute;
    },
    filteredNavigations() {
      const filterItems = (items) => {
        return items.filter(item => {
          if (Array.isArray(item.permission)) {
            return item.permission.some(permission => this.can(permission));
          } else if (item.permission) {
            return this.can(item.permission);
          }
          return true;
        }).map(item => {
          const filteredChildren = item.children ? filterItems(item.children) : [];
          return {
            ...item,
            ...(filteredChildren.length > 0 ? { children: filteredChildren } : {})
          };
        });
      };

      return filterItems(this.navigations);
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  data() {
    return {
      HeaderLogo,
      TelegramIcon
    };
  },
  methods:{
    can(permission) {
      return !!this.$store.state.permissionList.find(item => item.codeName === permission);
    }
  },
  setup() {
    const {type} = useBreakpoints();
    const isActive = ref(false);

    const toggleSidebar = (v) => {
      isActive.value = v;
    };

    return {
      screenType: type,
      toggleSidebar
    };
  }
};
</script>
<style>
@media (max-width: 991px) {
  .collapse-btn {
    position: absolute;
    right: 15px;
    width: 36px;
    height: 36px;
    svg{
      width: 12px;
    }
  }
  .mobile-collapsed-btn {
    width: 36px;
    height: 36px;
    svg{
      width: 12px;
    }
  }
}
</style>

